s = window.s || {};
s.dom = s.dom || {};

s.popup = {
	loading: false,
	cache: [],
	$holder: $('body'),
	makeId: function(){
		return (new Date()).getTime();
	},
	load: function(link, callback){
		if (this.loading) {
			return;
		}
		if (link.indexOf('#') === 0) {
			var tpl = s.dom.$body.find(link).text();
			var $popup = $(tpl);
			this.initClose($popup);
			this.$holder.append($popup);
			if ($.isFunction(callback)) {
				callback.apply(s, [$popup]);
			} else {
				this.show($popup);
			}
			
			$popup.data("key", this.makeId());
			this.cache.push($popup);
		} else {
			this.loading = true;
			var self = this;
			$.ajax({
				url: link,
				type: "get",
				dataType: "json",
				cache: true
			}).done(function(data){
				var $popup = $(data.content);
				
				self.initClose($popup);
				self.$holder.append($popup);
				
				for (var i = 0; i < s.initList.length; i++) {
					var _func = s.initList[i];
					try {
						if (s[_func]) {
							s[_func].apply(null, [$popup]);
						} else if ($.isFunction(_func)) {
							_func.apply(null, [$popup]);
						}
					} catch (e) {;}
				}
				s.initList = [];
				
				$popup.data("title", data.title);
				$popup.data("url", link);
				$popup.data("key", self.makeId());
				
				if ($.isFunction(callback)) {
					callback.apply(null, [$popup]);
				} else {
					self.show($popup);
				}
				
				self.cache.push($popup);
				
				history.pushState({}, data.title, link);
			}).fail(function(){
				alert('Ошибка подключения!');
			}).always(function(){
				self.loading = false;
			});
		}
	},
	show: function($popup, offset){
		$popup.css('height', $(document).height());
		$popup.css({
			'left': '-99999px',
			'top': 0
		}).show();
		this.align($popup, offset);
		$popup.hide()
			.css({'left': 0})
			.fadeIn(400);
		
		$.each(this.cache, function(){
			var $this = $(this);
			if ($this.data("key") == $popup.data("key")) {
				return;
			}
			$this.fadeOut(400, function(){
				$this.css({'left': '-99999px'});
			});
		});

		s.dom.$body.css({
			'overflow': 'hidden'
		});
		s.dom.$html.addClass('popup-active');
	},
	align: function($popup, offset){
		offset = offset || 0;
		var $window = $(window);
		var windowHeight = $window.outerHeight() - offset;
		
		var	$content = $popup.children('.popup');
		var contentHeight = $content.height();
		contentHeight += parseInt($content.css('padding-top').replace("px", ""));
		contentHeight += parseInt($content.css('padding-bottom').replace("px", ""));
		
		if ($content.css("position") == "fixed") {
			$content.css({
				'top': ((windowHeight - contentHeight) / 2),
				'left': (($window.width() - $content.outerWidth()) / 2)
			});
		} else {
			if (contentHeight > windowHeight){
				$content.css({
					'top': $window.scrollTop(),
					'left': (($window.width() - $content.outerWidth()) / 2) + $window.scrollLeft()
				});
			} else {
				$content.css({
					'top': ((windowHeight - contentHeight) / 2) + $window.scrollTop(),
					'left': (($window.width() - $content.outerWidth()) / 2) + $window.scrollLeft()
				});
			}
		}
	},
	initClose: function($popup){
		var self = this;
		$popup.find('.btn-close, .bg').click(function(e){
			e.preventDefault();
			
			self.cache = $.grep(self.cache, function(element) {
				return $popup.data("key") !== $(element).data("key");
			});
			
			$popup.fadeOut(400, function(){
				$popup.triggerHandler("popup.close", [$popup]);
				$popup.css({"left": "-9999px"})
					.remove();
			});
			
			if (self.cache.length > 0) {
				var $lastPopup = self.cache[self.cache.length - 1];
				self.show($lastPopup);
			}

			s.dom.$body.css({
				'overflow': 'visible'
			});
			s.dom.$html.removeClass('popup-active');
		});
	},
	closeAll: function(){
		if (this.cache.length > 0) {
			$.each(this.cache, function(){
				var $this = $(this);
				$this.fadeOut(400, function(){
					$this.triggerHandler("popup.close", [$this]);
					$this.css({"left": "-9999px"})
					.remove();
				});
			});
			this.cache = [];

			s.dom.$body.css({
				'overflow': 'visible'
			});
			s.dom.$html.removeClass('popup-active');
		}
	}
};

